import { Button, MenuItem } from "@mui/material";

import { IRules, IRulesCost } from "../../SetupLife.types";
import { Container, Row, Title, SelectForm, TextField, ButtonDelete } from "./Rules.styled";
import { formatCurrency, maskPercentage } from "./Rules.utils";

interface IProps {
  rules: IRules;
  handleChange: (payload: Partial<IRules>) => void;
}

export function RulesTabCost({ rules, handleChange }: IProps) {
  function handleChangeCost(payload: Partial<IRulesCost>) {
    const updatedCostFields = { ...rules.rulesCost, ...payload };

    handleChange({ ...rules, rulesCost: updatedCostFields });
  }

  return (
    <Container>
      <Title>Custeio</Title>
      <Row>
        <SelectForm
          label="Contribuição"
          value={rules.rulesCost.contribuicao}
          onChange={(e) => handleChangeCost({ contribuicao: e.target.value as string })}
        >
          <MenuItem value={"SIM"}>Sim</MenuItem>
          <MenuItem value={"NAO"}>Nao</MenuItem>
        </SelectForm>
        {rules.rulesCost.contribuicao === "SIM" && (
          <>
            <TextField
              label="Contribuição titular"
              value={maskPercentage(rules.rulesCost.contribuicaoTitular)}
              onChange={(e) => handleChangeCost({ contribuicaoTitular: e.target.value })}
            />
            <TextField
              label="Valor contribuição titular (R$)"
              value={formatCurrency(rules.rulesCost.contribuicaoTitularValor)}
              onChange={(e) => handleChangeCost({ contribuicaoTitularValor: e.target.value })}
            />
            <TextField
              label="Contribuição dependente"
              value={maskPercentage(rules.rulesCost.contribuicaoDependente)}
              onChange={(e) => handleChangeCost({ contribuicaoDependente: e.target.value })}
            />
          </>
        )}
      </Row>
      {rules.rulesCost.contribuicao === "SIM" && (
        <Row>
          <TextField
            label="Valor contribuição dependente (R$)"
            value={formatCurrency(rules.rulesCost.contribuicaoDependenteValor)}
            onChange={(e) => handleChangeCost({ contribuicaoDependenteValor: e.target.value })}
          />
        </Row>
      )}
    </Container>
  );
}
